"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./StoreInformationTile.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StoreInformationTile = _ref => {
  let {
    store,
    name,
    address,
    Organization,
    loginType,
    storeAlertList,
    everythingOkIcon,
    successLabel,
    rightButtonShow,
    onClick,
    arrowImage,
    isDisable = true,
    isSystem,
    infoContainerStyle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "storeInfomation-wrapper",
    onClick: onClick,
    style: _objectSpread({
      cursor: "pointer"
    }, infoContainerStyle)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "storeInfomation-infor"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "storeInformation-name",
    "data-testid": "storeName"
  }, name), Organization && loginType === "dispatcher" && /*#__PURE__*/_react.default.createElement("p", {
    className: "storeInformation-organization",
    "data-testid": "storeOrganization"
  }, Organization), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeInformation-address",
    "data-testid": "storeAddress"
  }, address), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeInfomation-iconwrapper"
  }, isSystem && (storeAlertList === null || storeAlertList === void 0 ? void 0 : storeAlertList.length) && isDisable && storeAlertList.map((alert, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i,
    className: "infoIcon-div",
    "data-testid": "infoIcon-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: alert.icon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: alert.type ? alert.type : "info",
    "data-testid": "storeTile-info"
  }, alert.count))), isSystem && !(storeAlertList !== null && storeAlertList !== void 0 && storeAlertList.length) && everythingOkIcon && isDisable && /*#__PURE__*/_react.default.createElement("div", {
    className: "everythingOkIcon-div",
    "data-testid": "everythingok-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: everythingOkIcon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "everythingOk",
    "data-testid": "everythingOK"
  }, successLabel)), isDisable ? "" : /*#__PURE__*/_react.default.createElement("div", {
    className: "everythingOkIcon-div",
    "data-testid": "everythingok-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: everythingOkIcon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "storeSubscription",
    "data-testid": "everythingOK"
  }, successLabel)))), rightButtonShow && /*#__PURE__*/_react.default.createElement("div", {
    className: "storeInfomation-navigateIcon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: arrowImage,
    alt: ""
  })));
};
var _default = exports.default = StoreInformationTile;